import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './styles/index.css';
import './styles/App.css';
import './styles/VenueCard.css';
import './styles/MapView.css';
import './styles/PartyButton.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
const bootStart = performance.now();
root.render(<App />);

// keep splash up for at least this long, counted from first JS execution
const SPLASH_MIN_MS = 1600;

function preload(url){
  return new Promise(res => {
    const img = new Image();
    img.onload = img.onerror = res;
    img.src = url;
  });
}

function delayUntil(start, minMs){
  const elapsed = performance.now() - start;
  return new Promise(res => setTimeout(res, Math.max(0, minMs - elapsed)));
}

const whenWindowLoaded = new Promise(res => {
  if (document.readyState === 'complete') res();
  else window.addEventListener('load', res, { once: true });
});

Promise.all([
  preload('./PartyButton.png'),                  // ✅ relative path for Capacitor
  whenWindowLoaded,
  delayUntil(bootStart, SPLASH_MIN_MS)
]).then(() => {
  requestAnimationFrame(() => document.body.classList.add('app-ready'));
});
